import Alerts from 'lib/alerts';
import template from 'commons/templates/LeaveRequestModal.ejs';
import rejectionTpl from 'commons/templates/LeaveRequestModal/Rejection.ejs';
import cancelationTpl from
    'commons/templates/LeaveRequestModal/Cancelation.ejs';
import awaitingTpl from 'commons/templates/LeaveRequestModal/Awaiting.ejs';
import ModalFormView from './ModalForm.js';
import moment from 'moment';
import {consts as LeaveRequestConsts} from 'newModels/leave-request.js';
import loader from 'helpers/loader';

module.exports = ModalFormView.extend({
    events: function() {
        return Object.assign({}, ModalFormView.prototype.events(), {
            'click .js-cancel-leave': 'cancelLeave',
            'click .js-reject': 'reject',
            'click .js-approve': 'approve',
            'click .js-reject-submit': 'rejectSubmit',
            'click .js-reject-cancel': 'rejectCancel'
        });
    },

    initialize: function(options) {
        this.options = Object.assign({
            template:      template,
            templateExtra: {}
        }, options || {});
        return ModalFormView.prototype.initialize.apply(this, [this.options]);
    },

    setModel: function(model) {
        const canCancel = function() {
            const iAmManager = model.userEmployee &&
                model.getEmployee() &&
                model.getEmployee().isManagedBy(model.userEmployee);

            // Employee himself
            if (
                !iAmManager && app.user.get('role') === 'employee' &&
                model.isAwaiting()
            ) {
                return true;
            }

            // Employer
            if (
                app.user.get('role') !== 'employee' &&
                model.isCancellable &&
                !model.isAwaiting()
            ) {
                return true;
            }

            // Manager
            if (iAmManager && !model.isAwaiting()) {
                return true;
            }

            return false;
        }();

        const canApprove = function() {
            if (!model.isAwaiting()) {
                return false;
            }
            if (app.user.get('role') !== 'employee') {
                return true;
            }
            if (
                model.userEmployee &&
                model.getEmployee() &&
                model.getEmployee().isManagedBy(model.userEmployee) &&
                model.getEmployee().getApprovalLayer(model.userEmployee) >
                    (model.get('approvalStatus') || 0)
            ) {
                return true;
            }
        }();

        Object.assign(this.options.templateExtra, {
            leaveType: model.getType(),
            isCancellable: model.isCancellable,
            daysAllowed: 2,
            period: this.getPeriod(model),
            isEmployee: app.user.get('role') === 'employee',
            canCancel: canCancel,
            canApprove: canApprove
        });

        return ModalFormView.prototype.setModel.apply(this, arguments);
    },

    render: function() {
        var statusMessage = false;
        if (this.model.isRejected()) {
            statusMessage = rejectionTpl({model: this.model});
        }

        if (this.model.isCancelled()) {
            statusMessage = cancelationTpl({model: this.model});
        }

        if (this.model.isAwaiting()) {
            statusMessage = awaitingTpl({model: this.model});
        }

        this.options.templateExtra.statusMessage = statusMessage;

        this.model.fetchDaysAllowed().then(days => {
            this.renderDaysAllowed(days);
        });

        return ModalFormView.prototype.render.apply(this, arguments);
    },

    renderDaysAllowed: function(days) {
        this.$('.js-allowed').text(days);
        this.$('.js-allowed-label')
            .text(((days > 0) ? 'days' : '') + ' allowed');
    },

    cancelLeave: function() {
        this.hide();

        Alerts.show('dangerConfirm', {
            text:     'You will not be able to recover this leave.',
            loader:   true,
            callback: isConfirm => {
                if (!isConfirm) {
                    return;
                }

                this.model.cancel()
                    .then(() => {
                        this.trigger('update');

                        Alerts.show('success', {
                            title: 'Leave Cancelled',
                            text:  'The leave has been cancelled'
                        });
                    })
                    .catch(err => { Alerts.show('criticalError', err); });
            }
        });
    },

    approve: function() {
        const stopLoader = loader.startFullScreen(this.$('.js-approve'));
        this.model.approve()
            .then(() => {
                this.trigger('update');

                Alerts.show('success', {
                    title: 'Leave Approved',
                    text:  'The leave has been approved'
                });
            })
            .catch(err => { Alerts.show('criticalError', err); })
            .finally(() => {
                this.hide();
                stopLoader();
            });
    },

    reject: function() {
        this.$('.modal-body.js-leave').hide();
        this.$('.modal-body.js-leave-reject').fadeIn(200);
        this.$('textarea.js-reason').focus();
        return false;
    },

    rejectCancel: function() {
        this.$('.modal-body.js-leave').fadeIn(200);
        this.$('.modal-body.js-leave-reject').hide();
        return false;
    },

    rejectSubmit: function() {
        const rejectReason = this.$('.js-reason').val();
        const stopLoader = loader.startFullScreen(this.$('.js-submit'));

        this.model.set({
            status: LeaveRequestConsts.STATUS_REJECTED,
            rejectReason: rejectReason
        });

        this.model.save()
            .then(() => {
                this.trigger('update');
                this.$('.js-reject-modal').off('hidden.bs.modal');

                Alerts.show('success', {
                    title: 'Leave Rejected',
                    text:  'The leave has been rejected'
                });
            })
            .catch(err => { Alerts.show('criticalError', err); })
            .finally(() => {
                this.hide();
                stopLoader();
            });
    },

    getPeriod: function(model) {
        model = model || this.model;

        if (
            !model.get('dateTo') ||
                this.getDateFromFormatted(model) ===
                    this.getDateToFormatted(model)
        ) {
            return moment.utc(model.get('dateFrom')).format('D MMM YYYY');
        }

        return (
            this.getDateFromFormatted(model) + ' to ' +
                this.getDateToFormatted(model)
        );
    },

    getDateFromFormatted: function(model) {
        return this.getDateFormatted('dateFrom', model);
    },

    getDateToFormatted: function(model) {
        return this.getDateFormatted('dateTo', model);
    },

    getDateFormatted: function(attr, model) {
        var r = '';

        model = model || this.model;

        if (!model.has(attr) && !model.get(attr)) {
            return r;
        }

        if (model[attr + 'IsMorning']()) {
            r += 'Morning of ';
        }

        if (model[attr + 'IsAfternoon']()) {
            r += 'Afternoon of ';
        }

        return r + moment.utc(model.get(attr)).format('D MMM YYYY');
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/LeaveRequestModal.js